import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from './toolbar.component';
import { MatToolbar } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MenuUserModule } from '../menu-user/menu-user.module';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    ToolbarComponent
  ],
  imports: [
    CommonModule,
    MatToolbar,
    MatIconModule,
    MenuUserModule,
    MatButtonModule
],
  exports: [
    ToolbarComponent
  ]
})
export class ToolbarModule { }
